import styled from 'styled-components';

import { BREAK_POINTS } from '@origin-digital/style-guide';

export const Card = styled.div`
  background-color: #ffffff;
  padding: 24px 16px;
  box-sizing: border-box;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 24px 32px;
    margin: 32px 0;
    width: 342px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 32px 32px;
    width: 462px;
  }
`;

export const HeadingContainer = styled.div`
  margin-bottom: 16px;
  h1 {
    margin-top: 0;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    margin-bottom: 24px;
  }
`;

export const PostcodeInputContainer = styled.div`
  margin-bottom: 24px;
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    margin-bottom: 32px;
  }
`;
